import { createContext } from "react";
import { ConfirmOptions } from "./ConfirmProvider";

export default createContext(
  (_options?: ConfirmOptions) => new Promise((resolve) => resolve(undefined))
);
